/**
 * Converts an arbitrary second value into the integer value shown on screen.
 * A partial second is kept visible (ceil) and expired values are clamped at 0.
 */
export function normalizeRemainingSeconds(value: number): number {
  if (!Number.isFinite(value)) {
    throw new RangeError("remainingSeconds must be a finite number");
  }

  return Math.max(0, Math.ceil(value));
}

/**
 * The normal carousel uses MM分SS秒 until 2:01. From 2:00 onward the event
 * screen deliberately switches to a single, large seconds value.
 */
export function formatCountdown(remainingSeconds: number): string {
  const normalized = normalizeRemainingSeconds(remainingSeconds);

  if (normalized <= 120) {
    return `${normalized}秒`;
  }

  const minutes = Math.floor(normalized / 60);
  const seconds = normalized % 60;

  return `${String(minutes).padStart(2, "0")}分${String(seconds).padStart(2, "0")}秒`;
}
